import type { DashboardEstimator } from '@paintscout/util/builder'

/**
 * The estimator(s) the leaderboard section should reflect.
 *
 * While masquerading, `user.user_id` is the masquerading staff member's own id, not a member
 * of the masqueraded company (masquerade only swaps company, never identity — see
 * docs/pitfalls/README.md). Falling back to it would point the leaderboard queries at someone
 * outside the company, so fall back to the first real company estimator instead when no
 * explicit Estimators filter is selected. (#23765)
 */
export function getLeaderboardEstimators({
  estimators,
  allEstimators,
  isMasquerading
}: {
  estimators: DashboardEstimator[]
  allEstimators: DashboardEstimator[]
  isMasquerading: boolean
}): DashboardEstimator[] {
  if (estimators?.length > 0) return estimators
  if (isMasquerading && allEstimators?.length > 0) return [allEstimators[0]]
  return []
}

export function getLeaderboardId({
  permissionToViewAllQuotes,
  userId,
  leaderboardEstimators
}: {
  permissionToViewAllQuotes: boolean
  userId: string
  leaderboardEstimators: DashboardEstimator[]
}): string {
  if (!permissionToViewAllQuotes) return userId
  return leaderboardEstimators?.[0]?.value ?? userId
}
